import { CheckCircle as CheckCircle2, Info, Warning as TriangleAlert, X } from "@phosphor-icons/react";
import { cn } from "@/lib/cn";
import { useToastStore, type ToastVariant } from "@/stores/toast";

const VARIANT_ICON: Record<ToastVariant, typeof Info> = {
  success: CheckCircle2,
  error: TriangleAlert,
  info: Info,
};

const VARIANT_TEXT: Record<ToastVariant, string> = {
  success: "text-accent",
  error: "text-danger",
  info: "text-info",
};

/** Mount once at the app root. Announces via aria-live="polite" per DESIGN.md §12. */
export function Toaster() {
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);

  return (
    <div aria-live="polite" aria-atomic="false" className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2">
      {toasts.map((item) => {
        const Icon = VARIANT_ICON[item.variant];
        return (
          <div
            key={item.id}
            role="status"
            className="pointer-events-auto flex items-center gap-2 rounded-sm border border-border bg-surface-3 px-4 py-2.5 text-body text-text-primary shadow-[var(--shadow-popover)]"
          >
            <Icon size={16} weight="regular" className={cn("shrink-0", VARIANT_TEXT[item.variant])} aria-hidden="true" />
            <span>{item.message}</span>
            <button
              type="button"
              aria-label="Dismiss"
              onClick={() => dismiss(item.id)}
              className="ml-1 text-text-muted hover:text-text-primary focus-visible:outline-2 focus-visible:outline-primary"
            >
              <X size={14} weight="regular" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
